var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 50,
    height: 50,
    viewBox: "0 0 124.000000 95.000000",
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.000000,95.000000) scale(0.100000,-0.100000)",
    fill: "#d60000",
    stroke: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M257 939 c-77 -18 -152 -68 -198 -132 -16 -22 -29 -44 -29 -49 0 -4 33 -8 73 -8 l72 0 23 49 c12 27 43 72 68 100 25 28 42 51 37 50 -4 -1 -25 -5 -46 -10z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M503 931 c-109 -37 -185 -114 -219 -220 -13 -42 -16 -80 -12 -185 4 -116 7 -137 29 -176 44 -81 59 -85 338 -88 278 -4 295 -1 312 58 9 29 8 43 -2 66 l-14 29 -217 5 c-217 5 -218 5 -243 31 -32 32 -48 125 -35 204 11 69 24 91 63 115 29 18 51 20 210 20 l177 0 0 80 0 80 -167 0 c-135 -1 -178 -4 -220 -19z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M960 866 l0 -73 84 -7 c47 -3 96 -10 110 -16 14 -5 26 -6 26 -1 0 15 -58 88 -87 108 -35 26 -109 63 -123 63 -6 0 -10 -29 -10 -74z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M4 666 c-3 -13 -4 -111 -2 -217 3 -185 4 -197 29 -249 14 -31 40 -72 57 -91 41 -47 139 -98 202 -106 l50 -6 0 85 0 86 -33 6 c-41 8 -99 66 -126 126 -38 87 -50 261 -24 368 5 21 3 22 -71 22 -71 0 -76 -1 -82 -24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M556 658 c-26 -36 -21 -93 10 -117 25 -20 39 -21 233 -21 232 0 242 -3 261 -68 13 -50 13 -146 -2 -194 -6 -21 -27 -52 -45 -68 l-34 -30 -274 0 -275 0 0 -81 0 -80 283 3 282 3 63 34 c71 38 120 92 154 167 40 90 35 316 -9 401 -36 70 -54 73 -360 73 -270 0 -272 0 -287 -22z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.d33a00edbed9a2a96e4f337af53650c3.svg";
export { ForwardRef as ReactComponent };